const CUSTOM_TAGS_SESSION_FLAG = 'clarity_custom_tags_sent';

const getUTM = (k) => sessionStorage.getItem(k) || undefined;

export function sendUTMsAsCustomTags() {
  if (sessionStorage.getItem(CUSTOM_TAGS_SESSION_FLAG)) return;

  try {
    if (typeof window !== 'undefined' && window.clarity) {
      const utmData = {
        utm_source: getUTM('utm_source'),
        utm_medium: getUTM('utm_medium'),
        utm_campaign: getUTM('utm_campaign'),
        utm_content: getUTM('utm_content'),
        fbclid: getUTM('fbclid')
      };

      Object.entries(utmData).forEach(([key, value]) => {
        if (value) {
          window.clarity('set', key, value);
        }
      });

      sessionStorage.setItem(CUSTOM_TAGS_SESSION_FLAG, '1');

      console.log('Clarity Custom Tags sent:', utmData);
    }
  } catch (error) {
    console.warn('Clarity Custom Tags failed:', error);
  }
}

export function sendCustomTag(key, value) {
  try {
    if (typeof window !== 'undefined' && window.clarity && value) {
      window.clarity('set', key, value);
    }
  } catch (error) {
    console.warn('Clarity Custom Tag failed:', error);
  }
}

export function setUserTypeTag(isLoggedIn) {
  sendCustomTag('user_type', isLoggedIn ? 'registered' : 'guest');
}